import { createPortal } from 'react-dom';
import styles from './ScenarioGenerator.module.css';
import type { FrameMismatchConfirm } from './hooks/useVideoHandlers';

interface FrameMismatchDialogProps {
  state: FrameMismatchConfirm | null;
  onSelect: (frame: 'confirmed' | 'displayed') => void;
  onConfirm: () => void;
  onCancel: () => void;
}

export function FrameMismatchDialog({ state, onSelect, onConfirm, onCancel }: FrameMismatchDialogProps) {
  if (!state) return null;

  return createPortal(
    <div className="confirm-dialog-overlay" onClick={onCancel}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 480 }}>
        <p className="confirm-dialog-message">
          <strong>確認</strong>
          シナリオで現在表示中の最初のフレームは選択されていません。このまま進めてよろしいですか？
        </p>
        <div className={styles.frameMismatchThumbnails}>
          <button
            type="button"
            className={`${styles.frameMismatchOption} ${state.selectedFrame === 'confirmed' ? styles.frameMismatchOptionSelected : ''}`}
            onClick={() => onSelect('confirmed')}
          >
            <img src={state.confirmedUrl} alt="選択中のフレーム" />
            <span className={styles.frameMismatchLabel}>選択中のフレーム</span>
          </button>
          <button
            type="button"
            className={`${styles.frameMismatchOption} ${state.selectedFrame === 'displayed' ? styles.frameMismatchOptionSelected : ''}`}
            onClick={() => onSelect('displayed')}
          >
            <img src={state.displayedUrl} alt="表示中のフレーム" />
            <span className={styles.frameMismatchLabel}>表示中のフレーム</span>
          </button>
        </div>
        <div className="confirm-dialog-buttons">
          <button type="button" className="btn-secondary" onClick={onCancel}>
            キャンセル
          </button>
          <button type="button" className="btn-primary" onClick={onConfirm}>
            動画を生成
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
